import styled from "styled-components";

export const Styled = styled.div`
  .log-group {
    &:last-child {
      margin-bottom: 0;
    }
  }

  .date-header {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    padding: 8px 16px;
    background: var(--color-gray-50, #f6f6f7);

    .date-label {
      color: var(--color-gray-300, #a1a2a7);
      font-size: var(--font-size-xs, 12px);
      font-weight: 700;
      line-height: var(--font-line-height-xs, 16px);
    }

    .date-full {
      display: block;
      color: var(--color-foreground, #404145);
      font-weight: 700;
      line-height: var(--font-line-height-md, 24px);
    }
  }

  .log-items {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    .log-item {
      border-bottom: 1px solid var(--color-gray-100, #e2e3e5);
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      td {
        padding: 8px 0;

        &:first-child {
          padding-left: 16px;
        }

        &:last-child {
          padding-right: 16px;
        }
      }

      .timestamp {
        span {
          &:nth-child(2) {
            color: var(--Grey-70, var(--Grey-70, #757576));
            font-size: var(--font-size-xs, 12px);
            line-height: var(--font-line-height-xs, 16px);
          }
        }
      }
    }
  }

  .loader-container {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const FetchingLoaderStyled = styled.div`
  height: 100%;
  width: 100%;
  background-color: var(--color-gray-50, #f6f6f7);
  border-radius: 0 0 8px 8px;
`;
